import {Component, OnInit} from '@angular/core';
import {ApiMode, ConfigService, CspType} from '@shared-library';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';
import {VaultProfile} from '@shared-library';
import {NGXLogger} from "ngx-logger";
import {environment} from '../../../environments/environment';
import {v4 as uuidv4} from 'uuid';

@Component({
    selector: 'app-auth-signin',
    templateUrl: './auth-signin.component.html',
    styleUrls: ['./auth-signin.component.css'],
    standalone: false
})
export class AuthSigninComponent implements OnInit {
  protected readonly CspType = CspType;
  protected readonly idmeButtonLogoSrc = "data:image/svg+xml,%3Csvg%20%20%20%20role%3D%22img%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20viewBox%3D%220%200%2030%2012%22%20%20%20%20fill%3D%22none%22%20%20%20%20aria-labelledby%3D%22idme-title%22%3E%3Ctitle%20id%3D%22idme-title%22%3EID.me%3C%2Ftitle%3E%3Cg%20fillRule%3D%22nonzero%22%20fill%3D%22none%22%3E%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M1.48515.0384H.96978C.32628.0384%200%20.24588%200%20.6551v10.12096c0%20.40922.32627.6167.96978.6167h.51537c.64332%200%20.96977-.20748.96977-.6167V.6551c0-.40922-.32645-.6167-.96977-.6167M7.67332%209.10802H6.14794V2.31206h1.52538c1.90854%200%202.30924%201.84782%202.30924%203.39798s-.4007%203.39798-2.30924%203.39798zm2.901%201.04522c0-1.20723.73212-2.22915%201.74336-2.58106.11573-.56263.17475-1.18411.17475-1.86214%200-3.65857-1.71147-5.67336-4.81911-5.67336h-3.3127c-.4629%200-.67823.23232-.67823.73114v9.88444c0%20.49882.21532.73114.67824.73114h3.31269c1.18475%200%202.16587-.29364%202.92723-.85876-.01542-.1217-.02623-.24512-.02623-.3714z%22%20%20%20%20%20%20%20%20%20%20%20%20fill%3D%22%23FFF%22%20%20%20%20%20%20%20%20%2F%3E%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M14.24058%2010.15324c0%20.68452-.51484%201.23952-1.14984%201.23952-.63518%200-1.14984-.555-1.14984-1.23952%200-.68453.51466-1.23952%201.14984-1.23952.635%200%201.14984.555%201.14984%201.23952%22%20%20%20%20%20%20%20%20%20%20%20%20fill%3D%22%23FFF%22%20%20%20%20%20%20%20%20%2F%3E%3Cpath%20%20%20%20%20%20%20%20%20%20%20%20d%3D%22M27.26344%205.99604c.00248.0298.00478.05941.00514.0896%200%20.04337-.0016.08769-.0062.13488-.01525.15857-.04236.30625-.08047.43922-.2536.88646-.96747%201.0435-1.58492%201.06604.08383-.38496.20718-.76209.35906-1.09489.30057-.66007.67788-1.07006.98466-1.07025.028%200%20.05547.0044.08347.013.01188.00362.02233.00973.04112.01967l.01276.0063c.00514.0023.01028.00459.01506.00803.01312.00898.02464.02082.0374.03343l.01046.0105c.0039.00383.00797.00765.0117.01204.0085.01032.01559.02236.02268.03401l.00921.0151c.00638.00993.01259.02005.01826.03209.00336.00707.0062.0149.01418.03553.00815.0216.01648.04337.02268.06706l.00567.02751c.00656.02847.01223.0575.01577.08789l.0023.03324zm2.17934%202.4177a.2772.2772%200%2000-.10652-.0256c-.15702-.00553-.26406.06095-.3587.22564-.056.09877-.11112.19926-.1657.29975-.2086.38305-.4241.77871-.73726%201.06223-.42534.38496-1.04102.56512-1.56898.46061-.31404-.06209-.53823-.30701-.67115-.5015-.24386-.35726-.36242-.83832-.34328-1.39274.77713-.0705%203.11951-.4438%203.30578-2.35791.03597-.37102-.06203-.70745-.28356-.97263-.2809-.33624-.72928-.52156-1.26238-.52156-1.56224%200-3.1041%201.76147-3.29958%203.76957-.05334.5508.01028%201.05974.18963%201.5129-.13362.13336-.2598.22946-.3851.29327-.1308.06725-.24422.08081-.32734.03973-.10297-.05158-.14462-.1811-.1611-.28045-.0615-.36777.0179-.79037.11183-1.22691.05547-.256.12477-.5229.18591-.75827.18874-.72618.38422-1.47718.319-2.23584-.05936-.69465-.51164-1.12603-1.18031-1.12603-.93753%200-1.5548.7212-1.95462%201.33943-.0085-.4608-.11041-.79533-.30997-1.01885-.1898-.21283-.46876-.32058-.82888-.32058-.91962%200-1.52928.69274-1.92803%201.29912.00531-.05578.01063-.11271.0163-.16946.02517-.26001.03651-.63256-.15578-.86239-.11466-.13717-.28693-.20652-.51218-.20652-.19885%200-.24847.00115-.46203.03917-.00212.00019-.20877.04394-.28728.1217-.1377.13621-.09393.32401-.06876.43138.00319.01356.00602.02598.00762.03649.01506.10374.01967.22142.01435.35917-.0287.72942-.15436%201.45827-.27363%202.07516-.06433.33243-.137.67058-.2086%201.00434-.15914.7405-.3236%201.50603-.40797%202.27595-.00904.08158.01259.15915.06079.21818.04838.05923.11661.0919.19211.09209l.04963.00038c.50526.00726%201.00185-.01529%201.11882-.32574.1292-.34274.20062-.7596.26389-1.12833l.02782-.16334c.14993-.84787.2809-1.4554.5448-2.23641.13592-.40254.3844-.76515.58537-1.03643.24333-.32822.50562-.64957.80176-.6576.12264-.00687.2024.03249.26265.11865.28764.41362-.07054%201.74866-.2233%202.31875-.03314.12322-.06115.22734-.07887.30376l-.10527.44037c-.15507.64211-.31528%201.306-.39752%201.97754a7.70047%207.70047%200%2000-.0225.20747l-.00692.09362.0647.05368c.13043.10909%201.06192-.04356%201.06955-.04604.34346-.12514.41825-.4736.44288-.58805.06398-.29631.12051-.59893.17492-.89123l.0039-.02178c.10261-.5508.2086-1.1207.36739-1.67053.30961-1.06987.72255-1.79986%201.22728-2.16973.21586-.15857.4374-.17614.53806-.04222.17439.23117.0638.85704.01648%201.12432-.06522.37063-.1487.74814-.2295%201.11285l-.00408.01872c-.05175.2325-.10315.46482-.151.6979-.14763.72235-.26885%201.6178.10846%202.13458.19194.26345.48897.3968.88294.3968.41754%200%20.81045-.15016%201.23632-.47265.11733-.0896.23571-.19372.3743-.3179.4794.58747%201.02401.83908%201.80965.83908%201.77721%200%202.61265-1.27295%203.08655-2.23048.05973-.12132.12654-.26136.16642-.38019.0592-.17652-.01134-.3691-.16021-.43845z%22%20%20%20%20%20%20%20%20%20%20%20%20fill%3D%22%23FFF%22%20%20%20%20%20%20%20%20%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

  loading: boolean = false
  showMessage: boolean = false

  submitted: boolean = false
  existingVaultProfile: VaultProfile = new VaultProfile()
  errorMsg: string = ""
  message: string = ""

  constructor(
    public configService: ConfigService,
    private authService: AuthService,
    private routerService: Router,
    private logger: NGXLogger,
  ) { }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    //TODO: parse urlParameters to determine the API mode
  }

  async signinWithIdentityProvider(cspType: CspType): Promise<void> {
    this.loading = true;
    this.errorMsg = "";

    try {
      const authorizeUrl = await this.buildOAuthAuthorizeUrl(cspType);
      window.location.assign(authorizeUrl);
    } catch (err) {
      this.loading = false;
      this.logger.error("failed to start CSP signin", err);
      this.errorMsg = "an unknown error occurred during sign-in";
    }
  }

  async buildOAuthAuthorizeUrl(cspType: CspType): Promise<string> {
    const state = uuidv4();
    const codeVerifier = this.generateCodeVerifier();
    const codeChallenge = await this.generateCodeChallenge(codeVerifier);
    const redirectUri = this.getCallbackUrl();
    const systemConfig = this.configService.systemConfig$;
    const clientId = systemConfig?.publicId || environment.org_credential_live_public_id;
    const apiMode = systemConfig?.apiMode || this.getApiModeFromPublicId(clientId);
    const authorizeUrl = new URL(`${environment.identity_api_endpoint_base}/oauth2/authorize`);

    sessionStorage.setItem(`fasten_oauth_context:${state}`, JSON.stringify({
      codeVerifier,
      publicId: clientId,
      apiMode,
    }));

    authorizeUrl.searchParams.set('response_type', 'code');
    authorizeUrl.searchParams.set('client_id', clientId);
    authorizeUrl.searchParams.set('redirect_uri', redirectUri);
    authorizeUrl.searchParams.set('scope', 'udap openid profile email');
    authorizeUrl.searchParams.set('state', state);
    authorizeUrl.searchParams.set('code_challenge', codeChallenge);
    authorizeUrl.searchParams.set('code_challenge_method', 'S256');
    authorizeUrl.searchParams.set('idp', cspType);
    authorizeUrl.searchParams.set('audience', redirectUri);

    return authorizeUrl.toString();
  }

  private getCallbackUrl(): string {
    if (environment.connect_base_domain === 'localhost') {
      return `${window.location.origin}/auth/callback`;
    }

    return `https://${environment.connect_base_domain}/auth/callback`;
  }


  private getApiModeFromPublicId(publicId: string): ApiMode {
    const publicIdParts = publicId.split('_');
    if (publicIdParts.length === 3 && publicIdParts[1] === ApiMode.Live) {
      return ApiMode.Live;
    }

    return ApiMode.Test;
  }

  private generateCodeVerifier(): string {
    const randomBytes = new Uint8Array(32);
    window.crypto.getRandomValues(randomBytes);
    return this.base64UrlEncode(randomBytes);
  }

  private async generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encodedVerifier = new TextEncoder().encode(codeVerifier);
    const digest = await window.crypto.subtle.digest('SHA-256', encodedVerifier);
    return this.base64UrlEncode(new Uint8Array(digest));
  }

  private base64UrlEncode(bytes: Uint8Array): string {
    let binary = '';
    bytes.forEach((byte) => binary += String.fromCharCode(byte));
    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  signinSubmit(){
    this.submitted = true;
    this.loading = true

    console.log("Signin", this.existingVaultProfile.email)
    this.authService.VaultAuthBegin(this.existingVaultProfile.email!, environment.csp_prompt_force)
      .then((resp) => {
        // In test mode, backend may have already set the auth cookie for CLEAR synthetic identities.
        // If so, skip the code page and go straight to dashboard.
        if (this.configService.systemConfig$?.apiMode === ApiMode.Test) {
          return this.authService.GetSessionInfo()
            .then((sessionInfo) => {
              this.loading = false
              if (sessionInfo) {
                const hasVerifiedIdentity = !!resp?.has_verified_identity;

                // Auth cookie is already set, we can go to the dashboard.
                // before we do that, lets see if the CSP token and Patient Demographics were already set (and set the configService accordingly)
                if(resp?.has_verified_identity && resp?.verified_identity_csp_type){
                  this.logger.info("setting verified identity csp_type csp type to", resp.verified_identity_csp_type)
                  this.configService.vaultProfileConfig = {
                    verifiedIdentityCspType: resp.verified_identity_csp_type,
                    verifiedIdentityPatientDemographics: resp.verified_identity_patient_demographics
                  }
                }

                return this.routerService.navigateByUrl(hasVerifiedIdentity ? 'dashboard' : '/auth/identity/verification')
              } else {
                return this.routerService.navigate(['auth/signin/code'], { queryParams: { currentEmail: this.existingVaultProfile.email }})
              }
            })
        } else {
          this.loading = false
          return this.routerService.navigate(['auth/signin/code'], { queryParams: { currentEmail: this.existingVaultProfile.email }})
        }
      })
      .catch((err)=>{
        this.loading = false
        if(err?.name){
          this.errorMsg = "email or password is incorrect"
        } else{
          this.errorMsg = "an unknown error occurred during sign-in"
        }
      })
  }

}
